import React, { useCallback, useEffect } from 'react';
import { connect } from 'react-redux';
import { PageHeader } from 'react-bootstrap';
import { Route } from 'react-router-dom';
import './Profile.scss';
import SubNavigation from '../SubNavigation/SubNavigation';
import ChangeLoginEmail from '../ChangeLoginEmail/ChangeLoginEmail';
import ChangePassword from '../ChangePassword/ChangePasswordForm';
import ChangeSecurityQuestions from '../ChangeSecurityQuestions/ChangeSecurityQuestions';
import PersonalInformation from '../PersonalInformation/PersonalInformation';
import LinkedAccounts from '../LinkedAccounts/LinkedAccounts';
import config from '../../config';
import * as actionCreators from '../../store/actions/login';
import { bindActionCreators } from 'redux';

const Profile = ({ location, match, profilePageOpened }) => {
    const getUrlPart = useCallback(() => {
        const urlParts = ['linkedaccounts', 'changeloginemail', 'ChangePassword', 'changesecurityquestions'];

        for (const part of urlParts) {
            if (location.pathname.includes(part)) {
                return part;
            }
        }

        return '';
    }, [location.pathname]);

    const getSubTitle = useCallback(() => {
        const urlPart = getUrlPart();

        let subTitle = '';
        switch (urlPart) {
            case '':
                subTitle = 'Personal Info';
                break;
            case 'linkedaccounts':
                subTitle = 'Linked Accounts';
                break;
            case 'changeloginemail':
                subTitle = 'Change Email';
                break;
            case 'ChangePassword':
                subTitle = 'Change Password';
                break;
            case 'changesecurityquestions':
                subTitle = 'Change Questions';
                break;
            default:
                subTitle = urlPart;
                break;
        }
        return subTitle;
    }, [getUrlPart]);

    const updateTitle = useCallback(() => {
        const subTitle = getSubTitle();
        document.title = `${subTitle} | ${config.AppTitle}`;
    }, [getSubTitle]);

    useEffect(() => {
        profilePageOpened();
    }, [profilePageOpened]);

    useEffect(() => {
        updateTitle();
    }, [location, updateTitle]);

    return (
        <div className="view-container userprofile has-subnav">
            <PageHeader>My Profile</PageHeader>

            <SubNavigation region="profile" comp="submenu" title="My Profile" subTitle={getSubTitle()} />

            <div className="view-content">
                <Route path={match.url} component={PersonalInformation} exact />
                <Route path={match.url + '/linkedaccounts'} component={LinkedAccounts} />
                <Route path={match.url + '/changeloginemail'} component={ChangeLoginEmail} />
                <Route path={match.url + '/ChangePassword'} component={ChangePassword} />
                <Route path={match.url + '/changesecurityquestions'} component={ChangeSecurityQuestions} />
            </div>
        </div>
    );
};

const mapStateToProps = (state) => {
    return state.login;
};

export default connect(mapStateToProps, (dispatch) => bindActionCreators(actionCreators, dispatch))(Profile);
